import { useCallback, useEffect, useRef, useMemo } from "react";
export default function useTimeout(callback: any | undefined, delay: number) {
  const timeoutRef = useRef(null);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    return () => {
      window.clearTimeout(timeoutRef.current);
    };
  }, []);

  const memoizedCallback = useCallback(
    (args?) => {
      //console.log("useTimeout callback", { args, callbackRef, timeoutRef });
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = null;
        callbackRef.current?.(args);
      }, delay);
    },
    [delay, timeoutRef, callbackRef],
  );

  return useMemo(() => memoizedCallback, [memoizedCallback]);
}
